module.exports = __webpack_public_path__ + "static/bars4-3d8e514962cd3e58f2824a8d2d0e23c5.png";